module.exports = __webpack_public_path__ + "img/shawbrook-bank-logo.25615aee.png";